import invest2 from '../../assets/Images/property/invest2.png'
import featuredimg3 from '../../assets/Images/property/featuredimg3.jpg'
import featuredimg2 from '../../assets/Images/property/featuredimg2.jpg'
import sale4 from '../../assets/Images/property/sale4.png'
import sale5 from '../../assets/Images/property/sale5.png'
import invest6 from '../../assets/Images/property/invest6.png'
import invest8 from '../../assets/Images/property/invest8.png'
import sale8 from '../../assets/Images/property/sale8.png'
import sale9 from '../../assets/Images/property/sale9.png'
   
   export const investment = [
    {
        image:featuredimg3,
        price:"810,550",
        est:"7,250",
        title:"Residential",
        address:"Menchester city",
        bed:"1",
        bath:"2",
        furniture:"Equity ownership",
    },
    {
        image:invest2,
        price:"4,025",
        est:"3,250",
        title:"Land",
        address:"Southfield Road, Oxford OX4",
        bed:"0",
        bath:"0",
        furniture:"Rentel Income",
    },
    {
        image:featuredimg2,
        price:"6,250",
        est:"17,250",
        title:"Industrial",
        address:"Leeds city center",
        bed:"3",
        bath:"2",
        furniture:"Joined venture",
    },
    {
        image:sale5,
        price:"345,450",
        est:"17,250",
        title:"Special purpose",
        address:"Derby side country ",
        bed:"3",
        bath:"2",
        furniture:"Rentel income",
    },
    {
        image:sale4,
        price:"645,000",
        est:"7,250",
        title:"Residential",
        address:"Southfield Road, Oxford OX4",
        bed:"3",
        bath:"2",
        furniture:"join venture",
    },
    {
        image:invest6,
        price:"20,000",
        est:"3,250",
        title:"Land",
        address:"Southfield Road, Oxford OX4",
        bed:"0",
        bath:"0",
        furniture:"join venture",
    },
    {
        image:sale8,
        price:"125,000",
        est:"7,250",
        title:"Industrial",
        address:"Menchester city",
        bed:"3",
        bath:"2",
        furniture:"join venture",
    },
    {
        image:invest8,
        price:"3,450",
        est:"17,250",
        title:"Land ",
        address:"Leeds city center",
        bed:"0",
        bath:"0",
        furniture:"Equity Ownership",
    },
    {
        image:sale9,
        price:"800,000",
        est:"7,250",
        title:"Special Purpose",
        address:"Southfield Road, Oxford OX4",
        bed:"3",
        bath:"2",
        furniture:"Equity Ownership",
    },
   
   
   
   
   

]